export class SignatureConnexion {
    IDSignatureParametreConnexion?: number
    IDSignatureParametre?: number
    IDSite!: number
    IDPeopleRepresentant?: number
    Token?: string
    OriginalToken?: string
    IsTokenModified?: boolean
    DateCre?: Date
    DateUpd?: Date
    TestStatus?: 'inactive' | 'active' | 'error'
    EstActif?: boolean

    constructor(data?: Partial<SignatureConnexion>) {
        Object.assign(this, data)
        if (this.EstActif) {
            this.TestStatus = "active"
        } else {
            this.TestStatus = this.TestStatus || 'inactive'
        }
        this.EstActif = this.EstActif !== undefined ? this.EstActif : true
        this.OriginalToken = this.Token
        this.IsTokenModified = false
    }
}